// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__2ykgG","author":"Table_author__14p8x","authorImage":"Table_authorImage__2hdYQ","unreadRow":"Table_unreadRow__1AS40"};